var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { Component } from "react";
import { Row } from "react-bootstrap";
import { FormattedMessage } from "@irati/utils/lang";
import ErrorText from "../ErrorText";
import Input from "../FormItem/Input";
import { AddButton, RemoveButton, RowRelative } from "./styled";
var AddRemoveInputList = /** @class */ (function (_super) {
    __extends(AddRemoveInputList, _super);
    function AddRemoveInputList(props) {
        var _this = _super.call(this, props) || this;
        _this.update = function () {
            _this.props.update(_this.state.inputs);
        };
        _this.addInput = function () {
            _this.setState(function (state) {
                var inputs = state.inputs;
                var maximumReached = true;
                if (inputs.length <= 15) {
                    inputs = __spreadArrays(inputs, [""]);
                    maximumReached = false;
                }
                else {
                    setTimeout(function () { return _this.setState({ maximumReached: false }); }, 3000);
                }
                return { inputs: inputs, maximumReached: maximumReached };
            }, _this.update);
        };
        _this.onChangeInput = function (valueToUpdate, indexToChange) {
            _this.setState(function (state) { return ({
                inputs: state.inputs.map(function (value, index) {
                    if (indexToChange === index) {
                        return valueToUpdate;
                    }
                    return value;
                })
            }); }, _this.update);
        };
        _this.removeInput = function (indexToRemove) {
            _this.setState(function (state) { return ({
                inputs: state.inputs.filter(function (_, index) { return index !== indexToRemove; }),
                maximumReached: false
            }); }, _this.update);
        };
        _this.state = {
            inputs: props.inputs,
            maximumReached: false
        };
        return _this;
    }
    AddRemoveInputList.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, validation = _a.validation, addButtonText = _a.addButtonText;
        var _b = this.state, inputs = _b.inputs, maximumReached = _b.maximumReached;
        return (React.createElement(React.Fragment, null,
            React.createElement(Row, null,
                React.createElement(Input, { name: "addRemoveInput", label: label, onChange: function (value) { return _this.onChangeInput(value, 0); }, value: inputs[0], validation: validation })),
            inputs.slice(1, inputs.length).map(function (value, index) { return (React.createElement(RowRelative, { key: index + 1 },
                React.createElement(Input, { name: "addRemoveInput", label: label, value: value, onChange: function (newValue) { return _this.onChangeInput(newValue, index + 1); }, validation: validation }),
                React.createElement(RemoveButton, { onClick: function () { return _this.removeInput(index + 1); } },
                    React.createElement(FormattedMessage, { id: "admin.components.emailDomain.addRemoveInputList.removeButton.text" })))); }),
            React.createElement(AddButton, { full: true, small: true, onClick: this.addInput }, addButtonText),
            maximumReached && (React.createElement(ErrorText, null,
                React.createElement(FormattedMessage, { id: "admin.components.emailDomain.addRemoveInputList.errorText" })))));
    };
    return AddRemoveInputList;
}(Component));
export default AddRemoveInputList;
